import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import {
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY,
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY_SUCCESS,
  GET_ADIB_PARTNERS_MONTHLY_SUMMARY_ERROR,
} from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getAdibPartnersMonthlySummary({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/monthly-partner-summary-adib`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADIB',
      },
      data: payload?.data,
    });

    if (response?.status === 200) {
      yield put({
        type: GET_ADIB_PARTNERS_MONTHLY_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ADIB_PARTNERS_MONTHLY_SUMMARY_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ADIB_PARTNERS_MONTHLY_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetAdibPartnersMonthlySummary() {
  yield takeEvery(GET_ADIB_PARTNERS_MONTHLY_SUMMARY, getAdibPartnersMonthlySummary);
}

function* getAdibPartnersMonthlySummarySaga() {
  yield all([fork(watchGetAdibPartnersMonthlySummary)]);
}

export default getAdibPartnersMonthlySummarySaga;
